import { Heading, StyleProps } from '@chakra-ui/react'
import { ContentNode, ContentNodeUtils } from '@helo/cms'
import { If, pipe } from '@helo/utils'

import { HeadingError } from '../../components/Errors/HeadingError'
import { Skeleton } from '../../components/SkeletonLoader'
import { TypeRenderer } from '../../datatypes/TypeRenderer'
import { createWidget } from '../widget-utils'

export interface HeadingWidgetProps extends StyleProps {
  text?: string
  contentNode?: ContentNode
  isLoading?: boolean
  url?: string | boolean
}

export const HeadingWidget = ({
  text,
  contentNode,
  isLoading,
  ...props
}: HeadingWidgetProps) => {
  const hasTextContent = !!text
  const hasContentNode = !!contentNode
  const hasResolvedContent =
    hasTextContent ||
    (contentNode?.data != null && String(contentNode.data) !== '')
  const showSkeleton =
    Boolean(isLoading) ||
    (hasContentNode && !hasTextContent && !hasResolvedContent)

  if (!hasTextContent && !hasContentNode) {
    return null
  }

  const contentNodeWithStyles =
    contentNode &&
    pipe(
      contentNode,
      If.then(
        (node: ContentNode) => ContentNodeUtils.isKind('FIELD')(node),
        (node: ContentNode) =>
          ContentNodeUtils.getOfType()(node as never) as ContentNode,
      ),
      ContentNodeUtils.setState([
        {
          state: {
            styles: { variant: 'pageTitle' },
            linkUrl: contentNode?.state?.linkUrl,
          },
        },
      ] as any),
    )

  return (
    <Skeleton isLoading={showSkeleton} w="200px" h="28px">
      <Heading variant="pageTitle" {...props}>
        {hasTextContent ? (
          text
        ) : hasContentNode ? (
          <TypeRenderer
            contentNode={contentNodeWithStyles!}
            isLoading={isLoading}
          />
        ) : null}
      </Heading>
    </Skeleton>
  )
}

export const HeadingWidgetDefinition = createWidget(HeadingWidget, {
  type: 'Heading',
  errorRenderer: HeadingError,
})
